export enum UnsavedChangesAction {
    Save = "Save",
    Discard = "Discard",
    Cancel = "Cancel",
}
